var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-box-container",on:{"click":_vm.$_onImageClick}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.src),expression:"src"}],attrs:{"width":_vm.imageWidth,"height":_vm.imageHeight},on:{"load":_vm.$_onImageLoadEnd}})])
}
var staticRenderFns = []

export { render, staticRenderFns }